module.exports = __webpack_public_path__ + "img/17_92.e0b4aa0b.png";